import React, { useEffect, useState } from 'react';
import { adminAPI } from '../../utils/api';
import StatsCard from '../../components/StatsCard';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Users, Play, DollarSign, Server, Loader2 } from 'lucide-react';

export default function AdminDashboardPage() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const res = await adminAPI.getStats();
      setStats(res.data);
    } catch {
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="w-5 h-5 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!stats) return null;

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-foreground">Tableau de bord admin</h2>
        <p className="text-sm text-muted-foreground">Vue d'ensemble du système</p>
      </div>

      {/* Stats globales */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatsCard
          title="Utilisateurs"
          value={stats.total_users}
          icon={Users}
        />
        <StatsCard
          title="Runs total"
          value={stats.total_runs}
          icon={Server}
        />
        <StatsCard
          title="Runs aujourd'hui"
          value={stats.runs_today}
          icon={Play}
        />
        <StatsCard
          title="Coût aujourd'hui"
          value={`${stats.cost_today_eur?.toFixed(2) || '0.00'}€`}
          icon={DollarSign}
        />
      </div>

      {/* Runs par statut */}
      <Card className="bg-card border-border">
        <CardHeader className="pb-3">
          <CardTitle className="text-sm font-semibold">Runs par statut</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
            {Object.entries(stats.status_counts || {}).map(([status, count]) => (
              <div key={status} className="p-3 rounded-lg bg-muted/50 text-center">
                <p className="text-xl font-bold text-foreground">{count}</p>
                <p className="text-xs text-muted-foreground capitalize mt-1">{status}</p>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      {/* Activité 7 jours */}
      {stats.daily_stats && stats.daily_stats.length > 0 && (
        <Card className="bg-card border-border">
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-semibold">Activité (7 derniers jours)</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-2">
              {stats.daily_stats.map((day) => (
                <div key={day._id} className="flex items-center justify-between py-2 border-b border-border last:border-0">
                  <span className="text-sm text-foreground">{day._id}</span>
                  <div className="flex items-center gap-4 text-sm">
                    <span className="text-muted-foreground">{day.count} run{day.count > 1 ? 's' : ''}</span>
                    <span className="text-muted-foreground">{(day.cost || 0).toFixed(4)}€</span>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
